import React from "react";
import "./MyInvitesCard.css";

export default function MyInvitesCard({
    invite = {
        id: "INV-1001",
        title: "Pure Vegetarian Food",
        venueName: "Italian Fortune Palace",
        tags: ["Vegetarian", "Italian"],
        photos: [
            "https://images.unsplash.com/photo-1559339352-11d035aa65de?q=80&w=600&auto=format&fit=crop",
            "https://images.unsplash.com/photo-1544025162-d76694265947?q=80&w=600&auto=format&fit=crop",
        ],
        dateLabel: "April 14, 2025",
        dayLabel: "Monday",
        timeRange: "10:00 PM - 1:00 AM",
        duration: "3 hours duration",
        locationLabel: "Dell Venue",
        location: "Downtown Location",
        contactLabel: "Venue contact",
        phone: "+91 9465787629",
        status: "Confirmed",
        guests: { male: 7, female: 5 }
    },
    onViewDetails, // optional callback
}) {
    const totalGuests = (invite.guests?.male || 0) + (invite.guests?.female || 0);
    const pad2 = (n) => String(n ?? 0).padStart(2, "0");

    return (
        <div className="miv-card">
            {/* Media column */}
            <div className="miv-mediaColumn">
                <div className="miv-media">
                    <div className="miv-photos">
                    <div className="miv-photo"><img src={invite.photos?.[1]} alt="venue 2" /></div>
                    <div className="miv-photo"><img src={invite.photos?.[0]} alt="venue 1" /></div>
                    </div>
                    <div className="miv-content">
                        <div className="miv-topRow">
                            <div className="miv-titleBlock">
                                <h3 className="miv-title">{invite.title}</h3>
                                <div className="miv-sub">{invite.venueName}</div>
                                <div className="miv-chips">
                                    {invite.tags?.map((t) => (
                                        <span className="miv-chip" key={t}>{t}</span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Info grid */}
                <div className="miv-infoGrid">
                    <div className="miv-infoItem">
                        <div className="miv-infoLabel">
                            <CalendarIcon /> Date
                        </div>
                        <div className="miv-infoPrimary">{invite.dateLabel}</div>
                        <div className="miv-infoSub">{invite.dayLabel}</div>
                    </div>

                    <div className="miv-infoItem">
                        <div className="miv-infoLabel">
                            <ClockIcon /> Time
                        </div>
                        <div className="miv-infoPrimary">{invite.timeRange}</div>
                        <div className="miv-infoSub">{invite.duration}</div>
                    </div>

                    <div className="miv-infoItem">
                        <div className="miv-infoLabel">
                            <PinIcon /> {invite.locationLabel}
                        </div>
                        <div className="miv-infoPrimary">{invite.location}</div>
                    </div>

                    <div className="miv-infoItem">
                        <div className="miv-infoLabel">
                            <PhoneIcon /> {invite.contactLabel}
                        </div>
                        <div className="miv-infoPrimary">{invite.phone}</div>
                    </div>
                </div>
            </div>

            {/* Main content */}


            {/* Guests summary */}
            <aside className="miv-guests">

                <div className="miv-actions">
                    {invite.status && <span className="miv-status">{invite.status}</span>}
                    <button
                        className="miv-ghostBtn"
                        onClick={() => onViewDetails?.(invite)}
                        type="button"
                    >
                        View Details
                    </button>
                </div>

                <div>
                <div className="miv-guestsHead">
                    <div className="miv-guestsTitle">Current Guest Count</div>
                    <div className="miv-total">Total: {totalGuests}</div>
                </div>

                <div className="miv-guestCards">
                    <div className="miv-guestCard miv-guestCard--male">
                        <div className="miv-guestNum">{pad2(invite.guests?.male)}</div>
                        <div className="miv-guestLabel">Male</div>
                    </div>
                    <div className="miv-guestCard miv-guestCard--female">
                        <div className="miv-guestNum">{pad2(invite.guests?.female)}</div>
                        <div className="miv-guestLabel">Female</div>
                    </div>
                </div>
                </div>
            </aside>
        </div>
    );
}

/* --- tiny inline icon components (pure SVG) --- */
function CalendarIcon() {
    return (
        <svg className="miv-ico" viewBox="0 0 24 24" aria-hidden="true">
            <rect x="3" y="4" width="18" height="17" rx="4" />
            <path d="M8 2v4M16 2v4M3 10h18" />
        </svg>
    );
}
function ClockIcon() {
    return (
        <svg className="miv-ico" viewBox="0 0 24 24" aria-hidden="true">
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3 2" />
        </svg>
    );
}
function PinIcon() {
    return (
        <svg className="miv-ico" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 22s7-6.5 7-12a7 7 0 1 0-14 0c0 5.5 7 12 7 12z" />
            <circle cx="12" cy="10" r="3" />
        </svg>
    );
}
function PhoneIcon() {
    return (
        <svg className="miv-ico" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M5 2h3l2 5-2 1a12 12 0 0 0 6 6l1-2 5 2v3a2 2 0 0 1-2 2 17 17 0 0 1-15-15 2 2 0 0 1 2-2z" />
        </svg>
    );
}
